import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { type ComponentProps, useState } from 'react';

import { Button } from '../Button/Button';
import { DialogCloseButton } from '../DialogCloseButton/DialogCloseButton';
import { PhotoEvidenceList } from '../PhotoEvidenceList/PhotoEvidenceList';

export const PhotoEvidenceDialogGallery = ({
  slotProps,
  showMoreImages,
}: {
  slotProps: {
    photoList: ComponentProps<typeof PhotoEvidenceList>;
  };
  showMoreImages: boolean;
}) => {
  const [photoModalOpen, setPhotoModalOpen] = useState(false);

  return (
    <>
      {showMoreImages ? (
        <Button size="medium" variant="secondary" data-testid="show-more-media" onClick={() => setPhotoModalOpen(true)}>
          Show more images & videos
        </Button>
      ) : null}
      <Dialog
        open={photoModalOpen}
        onClose={() => setPhotoModalOpen(false)}
        maxWidth="lg"
        aria-labelledby="evidence-photos"
      >
        <DialogTitle id="evidence-photos">Photo & Video Evidence</DialogTitle>
        <DialogCloseButton onClick={() => setPhotoModalOpen(false)} />
        <DialogContent>
          <PhotoEvidenceList openOnClick {...slotProps.photoList} />
        </DialogContent>
      </Dialog>
    </>
  );
};
